<script>
export default {
	name: 'Menu-Routes',
	functional: true,
	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			menu_drop: false,
			menu_navigator: null,
		};
	},
	methods: {
		listGenerator(items, isChild = false, parentName = '') {
			return (
				<ul
					class={isChild ? 'dropdown-menu' : 'nav-list'}
					aria-labelledby={isChild ? `navbarDropdown-${parentName}` : undefined}
				>
					{items.map(route => {
						let children;

						if (route.children)
							children = this.listGenerator(
								route.children,
								true,
								route.name || 'menu',
							);

						return (
							<li class={route.children ? 'nav-item dropdown' : 'nav-item'}>
								{route.children ? (
									<a
										href="#"
										class="nav-link dropdown-toggle"
										id={`navbarDropdown-${route.name || 'menu'}`}
										role="button"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										{this.$t(route.title)}
									</a>
								) : route.name ? (
									route.name === 'merchant-picker' ? (
										<a class="nav-link" onClick={this.showMerchantPicker}>
											{this.$t(route.title)}
										</a>
									) : (
										<router-link
											to={route}
											class={isChild ? 'dropdown-item' : 'nav-link'}
										>
											{this.$t(route.title)}
										</router-link>
									)
								) : (
									<a
										href="#"
										class="nav-link"
										onClick={e => e.preventDefault()}
									>
										{this.$t(route.title)}
									</a>
								)}
								{children}
							</li>
						);
					})}
				</ul>
			);
		},
		showMerchantPicker() {
			this.$emit('showMerchantPicker');
		},
	},
	render() {
		return <div class="menuArea">{this.listGenerator(this.items)}</div>;
	},
};
</script>
